import { BodyLight, Button, ButtonSizes } from '@/components/elements';
import { PageLayout } from '@/components/elements/PageLayout';
import { CommentsView } from './CommentsView';

export function Comments() {

  return <PageLayout
    title='Comments'
    actions={<></>}
  >
    <CommentsView/>
  </PageLayout>
};

